<template>
  <!-- 业绩指标 -->
  <div class="table_container">
    <table>
      <tbody align="center">
        <tr>
          <th>目标</th>
          <th colspan="8">关单</th>
          <th colspan="8">接单</th>
          <th rowspan="3">备注</th>
        </tr>
        <tr>
          <th rowspan="3">差距数据化</th>
          <th colspan="3">{{ queryParams.months }}月</th>
          <th colspan="3">年度累计</th>
          <th colspan="2">同期</th>
          <th colspan="3">{{ queryParams.months }}月</th>
          <th colspan="3">年度累计</th>
          <th colspan="2">同期</th>
        </tr>
        <tr>
          <th>目标</th>
          <th>预计完成</th>
          <th class="total_column">完成率</th>
          <th>目标</th>
          <th>预计完成</th>
          <th class="total_column">完成率</th>
          <th>同期完成</th>
          <th class="total_column">同比</th>
          <th>目标</th>
          <th>预计完成</th>
          <th class="total_column">完成率</th>
          <th>目标</th>
          <th>预计完成</th>
          <th class="total_column">完成率</th>
          <th>同期完成</th>
          <th class="total_column">同比</th>
        </tr>
        <tr>
          <!-- 关单-月-目标 -->
          <td @click="handleColumn('closeMonthObjectives')">
            <el-input-number
              v-if="editField === 'closeMonthObjectives'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.closeMonthObjectives"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.closeMonthObjectives }}
            </span>
          </td>
          <!-- 关单-月-预计完成 -->
          <td @click="handleColumn('closeMonthExpectedCompletion')">
            <el-input-number
              v-if="editField === 'closeMonthExpectedCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.closeMonthExpectedCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.closeMonthExpectedCompletion }}
            </span>
          </td>
          <!-- 关单-月-完成率 -->
          <th class="total_column">
            {{
              getRate(
                "closeMonthCompletionRate",
                form.closeMonthExpectedCompletion,
                form.closeMonthObjectives
              )
            }}
          </th>
          <!-- 关单-年-目标 -->
          <td @click="handleColumn('closeYearObjectives')">
            <el-input-number
              v-if="editField === 'closeYearObjectives'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.closeYearObjectives"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.closeYearObjectives }}
            </span>
          </td>
          <!-- 关单-年-预计完成 -->
          <td @click="handleColumn('closeYearExpectedCompletion')">
            <el-input-number
              v-if="editField === 'closeYearExpectedCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.closeYearExpectedCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.closeYearExpectedCompletion }}
            </span>
          </td>
          <!-- 关单-年-完成率 -->
          <th class="total_column">
            {{
              getRate(
                "closeYearCompletionRate",
                form.closeYearExpectedCompletion,
                form.closeYearObjectives
              )
            }}
          </th>
          <!-- 关单-同期-同期完成 -->
          <td @click="handleColumn('closePeriodCompletion')">
            <el-input-number
              v-if="editField === 'closePeriodCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.closePeriodCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.closePeriodCompletion }}
            </span>
          </td>
          <!-- 关单-同期-同比 -->
          <th class="total_column">
            {{
              getRate(
                "closePeriodRate",
                form.closeMonthExpectedCompletion,
                form.closePeriodCompletion
              )
            }}
          </th>
          <!-- 接单-月-目标 -->
          <td @click="handleColumn('receiveMonthObjectives')">
            <el-input-number
              v-if="editField === 'receiveMonthObjectives'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.receiveMonthObjectives"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.receiveMonthObjectives }}
            </span>
          </td>
          <!-- 接单-月-预计完成 -->
          <td @click="handleColumn('receiveMonthExpectedCompletion')">
            <el-input-number
              v-if="editField === 'receiveMonthExpectedCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.receiveMonthExpectedCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.receiveMonthExpectedCompletion }}
            </span>
          </td>
          <!-- 接单-月-完成率 -->
          <th class="total_column">
            {{
              getRate(
                "receiveMonthCompletionRate",
                form.receiveMonthExpectedCompletion,
                form.receiveMonthObjectives
              )
            }}
          </th>
          <!-- 接单-年-目标 -->
          <td @click="handleColumn('receiveYearObjectives')">
            <el-input-number
              v-if="editField === 'receiveYearObjectives'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.receiveYearObjectives"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.receiveYearObjectives }}
            </span>
          </td>
          <!-- 接单-年-预计完成 -->
          <td @click="handleColumn('receiveYearExpectedCompletion')">
            <el-input-number
              v-if="editField === 'receiveYearExpectedCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.receiveYearExpectedCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.receiveYearExpectedCompletion }}
            </span>
          </td>
          <!-- 接单-年-完成率 -->
          <th class="total_column">
            {{
              getRate(
                "receiveYearCompletionRate",
                form.receiveYearExpectedCompletion,
                form.receiveYearObjectives
              )
            }}
          </th>
          <!-- 接单-同期-同期完成 -->
          <td @click="handleColumn('receivePeriodCompletion')">
            <el-input-number
              v-if="editField === 'receivePeriodCompletion'"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form.receivePeriodCompletion"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form.receivePeriodCompletion }}
            </span>
          </td>
          <!-- 接单-同期-同比 -->
          <th class="total_column">
            {{
              getRate(
                "receivePeriodRate",
                form.receiveMonthExpectedCompletion,
                form.receivePeriodCompletion
              )
            }}
          </th>
          <!-- 备注 -->
          <td @click="handleColumn('remark')">
            <el-input
              v-if="editField === 'remark'"
              ref="focusRef"
              v-model="form.remark"
              size="mini"
              placeholder="请输入"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input>
            <span v-else>
              {{ form.remark }}
            </span>
          </td>
        </tr>
        <tr>
          <th>差距描述</th>
          <!-- 差距描述 -->
          <td colspan="17" @click="handleColumn('gapDescription')" align="left">
            <el-input
              v-if="editField === 'gapDescription'"
              ref="focusRef"
              v-model="form.gapDescription"
              size="mini"
              placeholder="请输入"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input>
            <span v-else>
              {{ form.gapDescription }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdatePerformanceIndicatorApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      form: this.getForm(),
      editField: "" // 编辑单元格
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.form = this.getForm(data || {});
      this.queryParams = { ...queryParams };
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        id: data.id || "",
        closeMonthObjectives: data.closeMonthObjectives ?? undefined, // 关单-月-目标
        closeMonthExpectedCompletion:
          data.closeMonthExpectedCompletion ?? undefined, // 关单-月-预计完成
        closeMonthCompletionRate: data.closeMonthCompletionRate || null, // 关单-月-完成率
        closeYearObjectives: data.closeYearObjectives ?? undefined, // 关单-年-目标
        closeYearExpectedCompletion:
          data.closeYearExpectedCompletion ?? undefined, // 关单-年-预计完成
        closeYearCompletionRate: data.closeYearCompletionRate || null, // 关单-年-完成率
        closePeriodCompletion: data.closePeriodCompletion ?? undefined, // 关单-同期-同期完成
        closePeriodRate: data.closePeriodRate || null, // 关单-同期-同比
        receiveMonthObjectives: data.receiveMonthObjectives ?? undefined, // 接单-月-目标
        receiveMonthExpectedCompletion:
          data.receiveMonthExpectedCompletion ?? undefined, // 接单-月-预计完成
        receiveMonthCompletionRate: data.receiveMonthCompletionRate || null, // 接单-月-完成率
        receiveYearObjectives: data.receiveYearObjectives ?? undefined, // 接单-年-目标
        receiveYearExpectedCompletion:
          data.receiveYearExpectedCompletion ?? undefined, // 接单-年-预计完成
        receiveYearCompletionRate: data.receiveYearCompletionRate || null, // 接单-年-完成率
        receivePeriodCompletion: data.receivePeriodCompletion ?? undefined, // 接单-同期-同期完成
        receivePeriodRate: data.receivePeriodRate || null, // 接单-同期-同比
        remark: data.remark || "", // 备注
        gapDescription: data.gapDescription || "" // 差距描述
      };
    },
    // 计算百分比 r1 / r2
    getRate(field, r1, r2) {
      if ((r1 !== 0 && !r1) || !r2) return "-";
      const rate = (r1 / r2) * 100;
      this.form[field] = Number(rate.toFixed(0));
      return `${rate.toFixed(0)}%`;
    },
    // 点击单元格编辑
    handleColumn(field) {
      this.form[field] = this.form[field] ?? undefined;
      this.editField = field;
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.focusRef)) {
          this.$refs.focusRef[0]?.focus();
        } else {
          this.$refs.focusRef?.focus();
        }
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = JSON.parse(
          JSON.stringify({ ...this.queryParams, ...this.form })
        );
        const res = await addOrUpdatePerformanceIndicatorApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.form.id = res.data.id;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
  }
  ::v-deep .el-input__inner {
    padding: 0 8px;
  }
  .total_column,
  .el-table__footer-wrapper tbody td.el-table__cell {
    background: #c0cfde !important;
  }
}
</style>
